// extracted by mini-css-extract-plugin
module.exports = {"topPromoBlock":"_5vWmT","content":"Kfx6v","image":"Wn09S","inner":"GOHES","close":"Fux5U","icon":"fYAhP"};